<div class="ps-2">
  <div style="background: #064D6D;border-radius: 0.5rem 0.5rem 0 0;color: white;font-size: 0.8rem"
       class="fw-normal p-2 fs-6">
    Current INR Result
  </div>
  <div
    style="color: #064D6D; background: white; display: flex; flex-direction: row; justify-content: space-between; border-radius: 0 0 0.5rem 0.5rem; ">
            <span class="d-flex p-3 align-items-center">
              <i class="pi pi-calendar text-primary text-body fs-2 "></i>
              <span class="flex flex-column fw-semibold  mx-2 text-center">
                INR Date
                <span>
                  {{inr.startDate | date: 'dd/M/yy'}}
                </span>
              </span>

            </span>

    <mat-divider vertical style="height: 50px; margin-top: auto; margin-bottom: auto;"></mat-divider>

    <span class="d-flex p-3 align-items-center">
              <svg style="width: 32px; height: 38px; " class="icon svg-inline--fa fa-capsules text-body fs-5"
                   aria-hidden="true" focusable="false" data-prefix="fas" data-icon="capsules" role="img"
                   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" data-fa-i2svg=""><path fill="currentColor"
                                                                                                   d="M555.3 300.1L424.3 112.8C401.9 81 366.4 64 330.4 64c-22.63 0-45.5 6.75-65.5 20.75C245.2 98.5 231.2 117.5 223.4 138.5C220.5 79.25 171.1 32 111.1 32c-61.88 0-111.1 50.08-111.1 111.1L-.0028 368c0 61.88 50.12 112 112 112s112-50.13 112-112L223.1 218.9C227.2 227.5 231.2 236 236.7 243.9l131.3 187.4C390.3 463 425.8 480 461.8 480c22.75 0 45.5-6.75 65.5-20.75C579 423.1 591.5 351.8 555.3 300.1zM159.1 256H63.99V144c0-26.5 21.5-48 48-48s48 21.5 48 48V256zM354.8 300.9l-65.5-93.63c-7.75-11-10.75-24.5-8.375-37.63c2.375-13.25 9.75-24.87 20.75-32.5C310.1 131.1 320.1 128 330.4 128c16.5 0 31.88 8 41.38 21.5l65.5 93.75L354.8 300.9z"></path></svg>
              <span class="flex flex-column fw-semibold  mx-2 text-center">
                Marevan Dose
                <span>
                  {{inr.currentDose}} mg
                </span>
              </span>
            </span>
    <mat-divider vertical style="height: 50px; margin-top: auto; margin-bottom: auto;"></mat-divider>

    <span class="d-flex p-3 align-items-center">
              <svg style=" width: 20px; height: 22px" class="icon svg-inline--fa fa-hourglass text-body fs-3 " aria-hidden="true"
                   focusable="false" data-prefix="far" data-icon="hourglass" role="img"
                   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor"
                                                                                                   d="M0 24C0 10.75 10.75 0 24 0H360C373.3 0 384 10.75 384 24C384 37.25 373.3 48 360 48H352V66.98C352 107.3 335.1 145.1 307.5 174.5L225.9 256L307.5 337.5C335.1 366 352 404.7 352 445V464H360C373.3 464 384 474.7 384 488C384 501.3 373.3 512 360 512H24C10.75 512 0 501.3 0 488C0 474.7 10.75 464 24 464H32V445C32 404.7 48.01 366 76.52 337.5L158.1 256L76.52 174.5C48.01 145.1 32 107.3 32 66.98V48H24C10.75 48 0 37.25 0 24V24zM99.78 384H284.2C281 379.6 277.4 375.4 273.5 371.5L192 289.9L110.5 371.5C106.6 375.4 102.1 379.6 99.78 384H99.78zM284.2 128C296.1 110.4 304 89.03 304 66.98V48H80V66.98C80 89.03 87 110.4 99.78 128H284.2z"></path></svg>
              <span class="flex flex-column fw-semibold  mx-2 text-center">
                INR Result
                <span>
                  {{inr.testValue}}
                </span>
              </span>
            </span>
  </div>
</div>
